import React                                      from 'react';
import { Redirect, RouteComponentProps }          from 'react-router-dom';
import { Observe }                                from 'rewire-core';
import { WithStyle, withStyles, FormView, Modal } from 'rewire-ui';
import { Theme }                                  from '@material-ui/core/styles';
import Routes                                     from '../Routes';
import authService                                from '../services/AuthService';
import Dialog                                     from '../ui/Dialog2';
import TitleWithFlowLogo                          from '../ui/TitleWithFlowLogo';
import Confirmation                               from './Confirmation';
import resetPasswordModel                         from './ResetPasswordModel';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
  },
});

interface IResetPasswordProps {
}

type ResetPasswordProps = WithStyle<ReturnType<typeof styles>, IResetPasswordProps & RouteComponentProps<any>>;

class ResetPassword extends React.Component<ResetPasswordProps> {
  constructor(props: ResetPasswordProps) {
    super(props);

    const { match } = props;
    const { token } = match.params;
    // const queryValues = qs.parse(location.search || '');
    resetPasswordModel.load(token);
    // resetPasswordModel.load(token, queryValues && queryValues.email as string);
  }

  componentWillUnmount() {
    resetPasswordModel.reset();
  }

  renderTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText='Reset' afterText='Password' />;
  };

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={resetPasswordModel.form} onSubmit={resetPasswordModel.actionFn('submit')}>
        <div className='content'>
          <resetPasswordModel.form.field.email.Editor className='span1' />
        </div>
        <div className='content'>
          <resetPasswordModel.form.field.newPassword.Editor className='span1' />
        </div>
        <div className='content'>
          <resetPasswordModel.form.field.confirmNewPassword.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    const {from}    = this.props.location.state as {from: string} || {from: {pathname: Routes.Home}};
    const {classes} = this.props;

    return <Observe render={() => {
      if (authService.isAuthenticated) {
        return <Redirect to={from} />;
      }

      return (
        <div className={classes.root}>
          {resetPasswordModel.isComplete
            ? <Confirmation type='success' redirectTo={Routes.Login} message='Password reset successfully. You will be redirected to the Sign In screen shortly.' />
            : <Dialog dialog={resetPasswordModel} hideBackdrop={true} disableTransition={true} title={this.renderTitle} maxWidth='xs'>
                <this.renderDialogContents />
              </Dialog>
          }
        </div>
      );
    }} />;
  }
}

export default withStyles(styles, ResetPassword);
